import React from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import Spacer from '~/components/Spacer'
import GoogleButton from '~/components/auth/LoginWithButtons/GoogleButton'
import TRACKING from '~/services/tracking'

const Container = styled.div`
  margin: ${(props) => (props.$alignWithEmailField ? '0' : '10px 0')};
  width: 100%;
`

/** Matches InputItemWrapper spacing used by LabeledSimpleInput (Email field). */
const EmailAlignedField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
  width: 100%;
`

const EmptyLabel = styled.span`
  font-family: ${(props) => props.theme.fonts.avenirNextDemi};
  font-size: 16px;
  line-height: 21px;
  color: transparent;
  user-select: none;
`

const Divider = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  color: ${(props) => props.theme.colors.text.label};
  font-size: 0.9rem;
  margin: 12px 0;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #e0e0e0;
  }

  span {
    padding: 0 10px;
  }
`

const ContinueWithButtons = ({ trackCheckoutLogin, isPayNYCFlow, alignWithEmailField }) => {
  const googleButton = (
    <GoogleButton
      onSuccess={() => {
        if (trackCheckoutLogin && isPayNYCFlow) {
          TRACKING.paynycParking.googleCheckoutLogin(isPayNYCFlow)
        }
      }}
    />
  )

  return (
    <Container $alignWithEmailField={alignWithEmailField}>
      {alignWithEmailField ? (
        <EmailAlignedField>
          <EmptyLabel aria-hidden="true">&nbsp;</EmptyLabel>
          {googleButton}
        </EmailAlignedField>
      ) : (
        googleButton
      )}
      {trackCheckoutLogin ? (
        <Divider>
          <span>or continue with email</span>
        </Divider>
      ) : (
        !alignWithEmailField && <Spacer mobile={10} desktop={25} />
      )}
    </Container>
  )
}

export default inject((all) => ({
  isPayNYCFlow: all.store.ui.isPayNYCFlow,
}))(observer(ContinueWithButtons))
